import { createSlice } from "@reduxjs/toolkit";

const wirelessData = {
  data: [
    {
      id: "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
      ssid: "dlink",
      band: ["2", "5", "6"],
      mloEnable: false,
      security: "WPA3-PERSONAL",
      wpaMode: "WPA3",
      encryption: "SAE-AES",
      password: "SecurePass123!",
      vlanId: 1,
      applyTo: {
        type: "all",
        targets: [],
      },
      broadcastSSID: true,
      enable: true,
    },
    {
      id: "aks0312f-58d3-8738-9735-ca2139a83819",
      ssid: "dlink3F",
      band: ["2", "5"],
      mloEnable: false,
      security: "WPA2-PERSONAL",
      wpaMode: "WPA2",
      encryption: "PSK-AES",
      password: "SecurePass123!",
      vlanId: 1,
      applyTo: {
        type: "all",
        targets: [],
      },
      broadcastSSID: true,
      enable: true,
    },
    {
      id: "85dc9562-ef3f-8738-9735-ca2139a83819",
      ssid: "dlink5F",
      band: ["2"],
      mloEnable: false,
      security: "WPA2-PERSONAL",
      wpaMode: "WPA2",
      encryption: "PSK-AES",
      password: "SecurePass123!",
      vlanId: 1,
      applyTo: {
        type: "all",
        targets: [],
      },
      broadcastSSID: true,
      enable: true,
    },
  ],
};

const clientsData = {
  data: [
    {
      clientName: "Client1",
      ipAddress: "192.168.1.100",
      macAddress: "00:1A:2B:3C:4D:5E",
    },
    {
      clientName: "Client2",
      ipAddress: "192.168.1.101",
      macAddress: "00:1A:2B:3C:4D:5F",
    },
  ],
};

const initialState = {
  wirelessData,
  clientsData,
};

export const wirelessSlice = createSlice({
  name: "wireless",
  initialState,
  reducers: {
    setSsidData: (state, action) => {
      state.wireless.data = action.payload;
    },
  },
});

export const { setSsidData } = wirelessSlice.actions;

export default wirelessSlice.reducer;
